import PlaybackBaseLoader from "components/shared/PlaybackBaseLoader/PlaybackBaseLoader";

(function() {
  const cfg = window.__playbackConfig;

  PlaybackBaseLoader.configure({
    baseUrl: cfg.baseUrl,
    canaryBaseUrl: cfg.canaryBaseUrl,
    imaUrl: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
    drmBlockerToggle: cfg.drmBlockerToggle,
    enableCustomSkipAdButtonToggle: cfg.enableCustomSkipAdButton,
    enableLivestreamingDrmUsingTokenToggle: cfg.enableLivestreamingDrmUsingToken,
    enableRefactoredBannerAdToggle: cfg.enableRefactoredBannerAd,
    enablePremierUserBannerAdsToggle: cfg.enablePremierUserBannerAds,
    useInsecureVpaidModeToggle: cfg.useInsecureVpaidMode,
    enableEmbedHideComponentToggle: cfg.enableEmbedHideComponent,
    enableVp9WebToken: cfg.enableVp9WebToken,
    enabledPersistentEmbedTopBar: cfg.enabledPersistentEmbedTopBar,
    enableOpenwrapPubmaticToggle: cfg.enableOpenwrapPubmatic,
    loadImaJsOnHead: cfg.loadImaJsOnHead,
    cppWatchpageEnabled: cfg.cppWatchpageEnabled,
    dvrEnabled: cfg.dvrEnabled,
    loadBaseJsInHead: cfg.loadBaseJsInHead,
    vodNewPremiumBanner: cfg.vodNewPremiumBanner
  });
})();
